import React from 'react';

const s = {
    overlay: {
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 9999, backdropFilter: 'blur(4px)',
    },
    card: {
        background: '#fff', borderRadius: 16, padding: '40px 36px',
        maxWidth: 440, width: '90%', textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
    },
    title: {
        fontSize: 22, fontWeight: 800, color: '#1a1d23',
        marginBottom: 8, marginTop: 16,
    },
    text: {
        fontSize: 14, color: '#6b7280', lineHeight: 1.6,
        marginBottom: 28,
    },
    btn: {
        width: '100%', padding: '13px 0', border: 'none', borderRadius: 10,
        fontWeight: 700, fontSize: 15, cursor: 'pointer',
        background: '#6366f1', color: '#fff', transition: 'opacity .2s',
    },
};

export default function TrialCreditPopup({ onClose }) {
    const dismiss = () => {
        localStorage.setItem('trial_popup_shown', 'true');
        onClose();
    };

    return (
        <div style={s.overlay}>
            <div style={s.card}>
                <img src="/logo.svg" alt="OrbitGrowth" style={{ height: 48, borderRadius: 10 }} />
                <div style={s.title}>Welcome! You received &euro;1.00 free credit</div>
                <div style={s.text}>
                    Try any service &mdash; your trial credit expires in 24 hours.
                </div>
                <button style={s.btn} onClick={dismiss}>
                    Start ordering
                </button>
            </div>
        </div>
    );
}
